import * as React from "react";
import type { SVGProps } from "react";
const SvgIcAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 8h8M8 4v8"
    />
  </svg>
);
export default SvgIcAdd;
